import { useContext, useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalBody, Table } from "reactstrap";

import { confirm } from "components/Confirmation";
import { formatNumber } from "services/Utils";
import AppContext from "AppContext";
import ordemServicoService from "services/OrdemServicoService";
import contratoService from "services/ContratoService";

export default function ModalSelecionarExecutor({ config, onClosed, onChange }) {
  const [valorTotal, setValorTotal] = useState()
  const [empresas, setEmpresas] = useState()
  const [idEmpresa, setIdEmpresa] = useState()
  const { state } = useContext(AppContext)

  useEffect(() => {
    if (config?.idOrdemServico) {
      setValorTotal(config.valorTotal)
    } else {
      setValorTotal()
    }
  }, [config?.idOrdemServico])

  useEffect(() => {
    if (config?.idContrato) {
      contratoService.listarDistribuicao(config.idContrato).then(res => {
        if (res.success) {
          setEmpresas(res.data)
        }
      })
    } else {
      setEmpresas()
    }
  }, [config?.idContrato])

  const valorTotalDistribuido = useMemo(() => {
    if (!empresas) return 0
    return empresas.map(el => el.ordenServicoRecebidas).reduce((total, valor) => total + valor, 0)
  }, [empresas])

  const handleChange = (value) => {
    setIdEmpresa(value)
  }

  const handleConfirmar = () => {
    confirm({
      header: 'Movimentação',
      text: 'Você deseja atribuir essa Ordem de Serviço para a empresa selecionada?',
      icon: 'bi-exclamation-triangle',
      onConfirm: async () => {
        await ordemServicoService.selecionarEmpresaExecutora(config.idOrdemServico, idEmpresa)
        onChange && onChange()
        onClosed && onClosed()
      }
    })
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        {(config && !!empresas) && (
          <>
            <h2>Selecionar Empresa Executora</h2>
            <hr />
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Empresa</th>
                  <th scope="col" className="text-right">Participação</th>
                  <th scope="col" className="text-right">Dist. Atual</th>
                  <th scope="col" className="text-right">Nova Dist.</th>
                </tr>
              </thead>
              <tbody>
                {empresas.map(el => (
                  <tr key={el.id}>
                    <td>
                      <label style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 10 }}>
                        <input
                          type="radio"
                          name="selecionado"
                          value={el.empresa.id}
                          checked={idEmpresa == el.empresa.id}
                          onChange={() => handleChange(el.empresa.id)}
                        />
                        <span style={{ whiteSpace: 'normal' }}>
                            {el.empresa.razaoSocial}
                        </span>
                      </label>
                    </td>
                    <td className="text-right">{formatNumber(el.participacao * 100)}%</td>
                    <td className="text-right">{formatNumber(valorTotalDistribuido == 0 ? 0 : el.ordenServicoRecebidas / valorTotalDistribuido * 100)}%</td>
                    <td className="text-right">{
                      idEmpresa ?
                        formatNumber((el.ordenServicoRecebidas + (idEmpresa == el.empresa.id ? valorTotal : 0)) / (valorTotalDistribuido + valorTotal) * 100) + '%'
                        : '-'
                    }
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="row">
              <div className="col-12 text-right">
                <Button color="primary" onClick={handleConfirmar} disabled={!idEmpresa}>Confirmar</Button>
                <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
              </div>
            </div>

          </>
        )}
      </ModalBody>
    </Modal>
  )
}